import request from "../request";
import Url from "../url/contract";

const getQuestionAndAnswerMemberList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getQuestionAndAnswerMemberList + path, data, options);
};
const getQuestionAndAnswerMemberDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getQuestionAndAnswerMemberDetails + path,
    data,
    options
  );
};
const getQuestionAndAnswerMemberStatus0 = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getQuestionAndAnswerMemberStatus0 + path,
    data,
    options
  );
};
const setQuestionAndAnswerMember = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setQuestionAndAnswerMember + path, data, options);
};
const updateQuestionAndAnswerMember = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(Url.updateQuestionAndAnswerMember + path, data, options);
};

const getMyQuestionAndAnswerMemberList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getMyQuestionAndAnswerMemberList + path,
    data,
    options
  );
};

export default {
  getQuestionAndAnswerMemberList,
  getQuestionAndAnswerMemberDetails,
  getQuestionAndAnswerMemberStatus0,
  setQuestionAndAnswerMember,
  updateQuestionAndAnswerMember,

  getMyQuestionAndAnswerMemberList,
};
